import { render } from "./business-info.vue?vue&type=template&id=4302b66b&scoped=true"
import script from "./business-info.vue?vue&type=script&lang=js"
export * from "./business-info.vue?vue&type=script&lang=js"

import "./business-info.vue?vue&type=style&index=0&id=4302b66b&lang=scss&scoped=true"

import exportComponent from "/opt/tegsoft/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4302b66b"]])

export default __exports__